(function(){
  var A = window.ASSETS || {};
  function url(n){ return A[n] || n; }

  var PRODUCT_HANDLE = 'handgefertigte-ledersandalen-herren';

  var galleryImgs = ['gal-4.jpg','gal-12.jpg','gal-13.png','gal-7.jpg'];
  var colors = [
    {name:'Gelbliches Braun', img:'gal-4.jpg'},
    {name:'Rotbraun', img:'gal-12.jpg'},
    {name:'Schwarz', img:'gal-13.png'}
  ];
  var sizes = [38,39,40,41,42,43,44,45,46,47,48];
  var occasions = [
    {img:'gal-4.jpg',t:'Freizeit'},{img:'gal-7.jpg',t:'Reisen'},{img:'gal-13.png',t:'Büro'},
    {img:'gal-12.jpg',t:'Strand'},{img:'gal-4.jpg',t:'Wandern'},{img:'gal-7.jpg',t:'Alltag'}
  ];
  var reviews = [
    {n:'Markus W.',t:'Endlich Sandalen, in denen ich den ganzen Tag stehen kann, ohne Rückenschmerzen. Das Leder ist wunderschön verarbeitet.'},
    {n:'Thomas B.',t:'Sehr bequem und die Passform ist perfekt. Habe eine Nummer größer bestellt wegen meines breiten Fußes — top Entscheidung.'},
    {n:'Andreas K.',t:'Meine Knieschmerzen sind spürbar besser geworden. Sehen edel aus und passen zu allem. Klare Empfehlung!'}
  ];

  var selectedColor = 'Gelbliches Braun';
  var selectedSize = null;
  var variantMap = {};     // "Farbe / Größe" -> variant id

  function key(c,s){ return c + ' / ' + s; }

  // recupera le varianti reali del prodotto Shopify (solo sul negozio live)
  fetch('/products/' + PRODUCT_HANDLE + '.js')
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){
      if(!p || !p.variants) return;
      p.variants.forEach(function(v){
        variantMap[key(v.options[0], String(v.options[1]))] = v.id;
      });
    })
    .catch(function(){});

  var mainImg = document.getElementById('mainImg');
  var thumbs = document.getElementById('thumbs');
  galleryImgs.forEach(function(im,i){
    var t=document.createElement('img');
    t.src=url(im); if(i===0)t.className='on';
    t.onclick=function(){mainImg.src=url(im);[].forEach.call(thumbs.children,function(c){c.classList.remove('on')});t.classList.add('on')};
    thumbs.appendChild(t);
  });

  var sw=document.getElementById('swatches');
  colors.forEach(function(c,i){
    var d=document.createElement('div');d.className='swatch'+(i===0?' on':'');
    d.innerHTML='<img src="'+url(c.img)+'">';
    d.onclick=function(){selectedColor=c.name;document.getElementById('colorName').textContent=c.name;mainImg.src=url(c.img);[].forEach.call(sw.children,function(x){x.classList.remove('on')});d.classList.add('on')};
    sw.appendChild(d);
  });

  var sz=document.getElementById('sizes');
  sizes.forEach(function(s){
    var b=document.createElement('div');b.className='size';b.textContent=s;
    b.onclick=function(){selectedSize=String(s);document.getElementById('sizeName').textContent='EU '+s;[].forEach.call(sz.children,function(x){x.classList.remove('on')});b.classList.add('on')};
    sz.appendChild(b);
  });

  var oc=document.getElementById('occ');
  occasions.forEach(function(o){oc.insertAdjacentHTML('beforeend','<div><img src="'+url(o.img)+'"><span>'+o.t+'</span></div>')});

  var cs=document.getElementById('colorShow');
  colors.forEach(function(c){cs.insertAdjacentHTML('beforeend','<div><img src="'+url(c.img)+'"><span>'+c.name+'</span></div>')});

  var rv=document.getElementById('reviews');
  reviews.forEach(function(r){rv.insertAdjacentHTML('beforeend',
    '<div class="rev"><div class="rstars">★★★★★</div><p>“'+r.t+'”</p><div class="who"><i>'+r.n[0]+'</i><span>'+r.n+' <span class="ver">✔ Verifizierter Kauf</span></span></div></div>')});

  window.q=function(n){var i=document.getElementById('qty');i.value=Math.max(1,parseInt(i.value)+n)};

  window.buy=function(){
    if(!selectedSize){
      alert('Bitte wählen Sie zuerst eine Größe.');
      document.getElementById('sizes').scrollIntoView({behavior:'smooth',block:'center'});
      return;
    }
    var qty = parseInt(document.getElementById('qty').value) || 1;
    var vid = variantMap[key(selectedColor, selectedSize)];

    if(vid){
      // negozio Shopify live: aggiunge al carrello e va al checkout
      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ items:[{ id: vid, quantity: qty }] })
      })
      .then(function(r){ return r.json(); })
      .then(function(){ window.location.href = '/checkout'; })
      .catch(function(){ window.location.href = '/cart'; });
    } else {
      // anteprima locale (nessun prodotto Shopify collegato)
      alert('Vorschau — auf dem Live-Shop wird das Produkt in den Warenkorb gelegt:\n' +
            selectedColor + ' / EU ' + selectedSize + ' × ' + qty);
    }
  };
})();
